module.exports = __webpack_public_path__ + "static/img/img-ycz.574494e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/img-ycz.png
// module id = 1WY7
// module chunks = 0